import Container from "client/common/components/layouts/Container";

import { HeadingBlock as HeadingBlockType } from "../../types";
import MarkdownText from "../helper/MarkdownText";

import styles from "../../styles/HeadingBlock.module.less";

type HeadingBlockProps = {
  className?: string;
  block: HeadingBlockType;
};

const HeadingBlock = ({ block, className }: HeadingBlockProps) => {
  return (
    <div className={className}>
      <Container>
        <div className={styles.container}>
          {block.preheader && (
            <p className={styles.preheader}>
              <MarkdownText value={block.preheader} />
            </p>
          )}
          {block.header && (
            <h2 className={styles.header} style={{ maxWidth: block.width ?? 650 }}>
              <MarkdownText value={block.header} />
            </h2>
          )}
        </div>
      </Container>
    </div>
  );
};

export default HeadingBlock;
